import React from "react";
import Footer from "./sections/Footer";
import About from "./sections/About";
import Contact from "./sections/Contact";
import Works from "./sections/Works";
import MainSlider from "./sections/MainSlider";

const MainPage = () => {
  return (
    <>
      <MainSlider />
      <Works />
      <About />
      <Contact />
      <Footer />
    </>
  );
};

export default MainPage;
